// https://github.com/aws/aws-amplify/issues/678 fix
if (global === undefined) {
  var global = window;
}
